import { Row, Col } from "react-bootstrap";
import PricingCard from "./PricingCard";
import PlatformFeatures from "./PlatformFeatures";
import WhyTeamsPrefer from "./WhyTeamsPrefer";
import PriceCalculation from "../Home/PriceCalculation";

const Pricing = () => {
  return (
    <>
      <div className="pricing-section">
        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="pricing-title">
            Let's build your <span>plan</span>
          </h2>
          <p className="pricing-subtitle">
            Get started by getting in touch and sharing your user count and
            integration needs to receive a Product pricing estimate.
          </p>
          <p className="text">
            Next, we'll assess your feature requirements and arrange a
            customized demo.
          </p>
        </div>

        {/* Cards */}
        <Row className="g-4">
          <Col md={4}>
            <PricingCard
              title="Startup Plan"
              // price="25"
              description="Best for startups beginning their ERP journey."
              features={[
                "10-25 employees",
                // "User & Role Management",
                // "Basic Dashboard & Reports",
                // "Purchase Requisition",
                // "Vendor Master",
                // "Basic Inventory Tracking",
                // "Email Notifications",
              ]}
              // disabledFeatures={[
              //   "Purchase Order Automation",
              //   "Approval Workflows",
              //   "Accounts Payable & Receivable",
              //   "GST & Tax Management",
              //   "Advanced Reports & Analytics",
              //   "Multi-Company Support",
              //   "API & Third-party Integrations",
              // ]}
            />
          </Col>
          <Col md={4}>
            <PricingCard
              title="Professional"
              // price="50"
              description="Ideal for growing businesses needing full operational control."
              features={[
                "20-100 employees",
                // "Everything in Startup",
                // "Purchase Orders (PO)",
                // "Approval Workflows",
                // "Inventory & Warehouse Management",
                // "Accounts Payable & Receivable",
                // "GST & Tax Management",
                // "Vendor Performance Tracking",
                // "Standard Reports & Analytics",
              ]}
              // disabledFeatures={[
              //   "Multi-Company Management",
              //   "Custom Workflows",
              //   "Advanced Analytics Dashboard",
              //   "Dedicated Account Manager",
              // ]}
            />
          </Col>

          {/* ENTERPRISE PLAN */}
          <Col md={4}>
            <PricingCard
              title="Enterprise"
              // price="100"
              description="For large organizations with complex ERP requirements."
              features={[
                "100+ employees",
                // "Everything in Professional",
                // "Multi-Company & Multi-Location Support",
                // "Advanced Financial Reporting",
                // "Custom Workflows & Approvals",
                // "Project & Cost Management",
                // "API & ERP Integrations",
                // "Role-based Security Controls",
                // "Audit Logs & Compliance Reports",
                // "Dedicated Account Manager",
                // "Priority Support & SLA",
              ]}
            />
          </Col>
        </Row>
        <PriceCalculation />
        <h1 className="d-flex justify-content-center pt-4 pb-3">
          What’s included in the VENSAP Platform
        </h1>
        <PlatformFeatures />
      </div>
      <WhyTeamsPrefer
        title="Request pricing, tailored to your"
        highlight="business needs"
        buttonLabel="Request for Pricing"
      />
    </>
  );
};

export default Pricing;
